module.exports = __webpack_public_path__ + "static/media/katheryn-winnick-icon.96d7bfdf.jpg";